import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { ClientfinalCraService } from './../../../../../core/services/clientfinal-cra/clientfinal-cra.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-workflow-list',
  templateUrl: './workflow-list.component.html',
  styleUrls: ['./workflow-list.component.css'],
})
export class WorkflowListComponent {
  currentYear!: number;
  currentUser: any;
  id: any;
  listOfMonths: any;
  company_id: any;
  listWorkFlow: any;
  listWorkFlowConsultant: any;
  sortAttr = '';
  totalItems!: number;
  totalItemsconsul!: number;
  currentSortDirection: number = 2;
  pagination : boolean =false;

  itemsPerPage: number = 5;
  currentPage: number = 1;
  listWorkFlowClient: any;
  startIndex: number = 0;
  endIndex: number = 5;
  private unsubscribeAll: Subject<void> = new Subject();
  searchForm: FormGroup = this.createSearchForm();
  constructor(
    private servicecraclient: ClientfinalCraService,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getAllListOfWorkFlowCra();
    this.getListWorkflowClient();
    this.getListWorkflowConsultant();
  }

  /* list list workflow General */
  getAllListOfWorkFlowCra() {
    this.spinner.show();
    this.servicecraclient
      .getAllListOfWorkFlowCra(this.company_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listWorkFlow = res.data;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  /* list list workflow client  */
  getListWorkflowClient() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? {
            company_id: this.company_id,
            state_workflow: 2,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              company_id: this.company_id,
              state_workflow: 2,
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.servicecraclient
      .getListWorkflowClient(dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('resclient', res);
          this.listWorkFlowClient = res.data.items.data;
          this.totalItems = res.data.items.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  /* list list workflow consultant  */
  getListWorkflowConsultant() {
    this.spinner.show();
    let dataPyload =
      this.sortAttr == ''
        ? {
            company_id: this.company_id,
            state_workflow: 3,
            per_page: this.itemsPerPage,
            page: this.currentPage,
          }
        : {
            ...{ per_page: this.itemsPerPage, page: this.currentPage },
            ...{
              company_id: this.company_id,
              state_workflow: 3,
              sort: this.currentSortDirection,
              sortAttribute: this.sortAttr,
            },
          };
    this.servicecraclient
      .getListWorkflowConsultant(dataPyload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('resclient', res);
          this.listWorkFlowConsultant = res.data.items.data;
          this.totalItemsconsul = res.data.items.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  /* get indexes for pagination */
  getItems(event?: any) {
    if (
      event &&
      (event.startIndex !== this.startIndex ||
        this.endIndex !== event.endIndex ||
        this.itemsPerPage !== event.itemsPerPage ||
        this.currentPage !== event.currentPage)
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;
      if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
        this.getListWorkflowClient(); // Make sure to call the API here

      }
    }
  }
  getItemsconsultant(event?: any) {
    if (
      event &&
      (event.startIndex !== this.startIndex ||
        this.endIndex !== event.endIndex ||
        this.itemsPerPage !== event.itemsPerPage ||
        this.currentPage !== event.currentPage)
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;

      this.getListWorkflowConsultant();
    }
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  /*delete workflow*/
  deleteWorkFlowClient(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui, supprimer !',
    }).then((result) => {
      if (result.isConfirmed) {
        this.servicecraclient.deleteWorkflow(id).subscribe((res: any) => {
          console.log('responce', res);
          this.toastrService.success(
            'WorkFlow Client  a été supprimé.avec succès .'
          );
          this.getListWorkflowClient();
        });
      }
    });
  }
  /*delete workflow Consultant*/
  deleteWorkFlowConsultant(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui, supprimer !',
    }).then((result) => {
      if (result.isConfirmed) {
        this.servicecraclient.deleteWorkflow(id).subscribe((res: any) => {
          console.log('responce', res);
          this.toastrService.success(
            'WorkFlow Consultant a été supprimé.avec succès .'
          );
          this.getListWorkflowConsultant();
        });
      }
    });
  }
  createSearchForm(data?: any) {
    return this.formBuilder.group({
      workflow_id: [data ? data.workflow_id : ''],
      consultant_name: [data ? data.consultant_name : ''],
      company_name: [data ? data.company_name : ''],
      workflow_date: [data ? data.workflow_date : ''],
      company_id: this.localStorageService.getData('clientConnected'),
    });
  }
  searchWorkflow() {
    let data = {
      workflow_id: this.searchForm.value.workflow_id,
      consultant_name: this.searchForm.value?.consultant_name,
      workflow_date: this.searchForm.value.workflow_date,
      company_name: this.searchForm.value.company_name,
      page: this.currentPage,
      per_page: this.itemsPerPage,
    };

    if (this.searchForm.value.consultant_name === '') {
      delete data.consultant_name;
    }
    if (this.searchForm.value.workflow_id === '') {
      delete data.workflow_id;
    }
    if (this.searchForm.value.company_name === '') {
      delete data.company_name;
    }
    if (this.searchForm.value.workflow_date === '') {
      delete data.workflow_date;
    }
    if (this.searchForm.value.workflow_date === '') {
      delete data.workflow_date;
    }

    this.spinner.show();

    this.servicecraclient
      .searchworkflowclient(data, this.company_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listWorkFlowClient = res.data.items.data;
          this.listWorkFlowConsultant = res.data.items.data;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  onRightClick(event: MouseEvent) {
    event.preventDefault(); // Empêche le menu contextuel par défaut
  }
  
  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
  }
}
